// extracted by mini-css-extract-plugin
export default {"wrap":"ElecRecord_wrap__LxFAa","top":"ElecRecord_top__FjcRk","export":"ElecRecord_export__L0WKI"};